// extracted by mini-css-extract-plugin
export default {"container":"alert_container__5bvcc","info":"alert_info__LmPWc","image":"alert_image__s-zCI","text":"alert_text__mAvo4"};